import { useRef } from "react";
import { Backdrop, effectPlan } from "@/components/landing/Hero";
import { HeroLetters } from "@/components/landing/HeroLetters";
import { SiteContentOverride } from "@/lib/siteContent";
import { mapFor, useBox } from "@/lib/heroLayout";

const SIZES = { desktop: [1440, 810], sideways: [844, 390], phone: [390, 844] };
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u?.startsWith("/api/") ? `${BACKEND}${u}` : u);

// Renders the real homepage hero on a virtual desktop or phone stage, scaled to fit; contour pieces drag on desktop
export const LetteringPreview = ({ content, src, kind, layout, anchor, onDrag, device = "desktop" }) => {
  const ref = useRef(null);
  const { w } = useBox(ref);
  const [VW, VH] = SIZES[device];
  const scale = w ? w / VW : 0;
  const map = anchor ? mapFor(anchor, VW, VH, content["hero.car_pos"]) : null;
  const lay = device === "phone" ? (layout === "contour" && map ? "contour-phone" : "mobile") : layout === "contour" || layout === "door" ? (map ? layout : "classic") : layout;
  const shade = lay === "classic" || lay === "split" ? "bg-gradient-to-r from-black/85 via-black/45 to-black/10" : "bg-gradient-to-t from-black/80 via-black/20 to-black/40";
  return (
    <div className={device === "phone" ? "max-w-[260px] mx-auto" : device === "sideways" ? "max-w-[640px] mx-auto" : ""}>
      <div ref={ref} className={`relative w-full overflow-hidden bg-black border border-cyan-400/20 select-none ${device !== "desktop" ? "rounded-[28px]" : "rounded-xl"}`}
        style={{ aspectRatio: `${VW}/${VH}` }} data-testid={`lettering-preview-${device}`}>
        {scale > 0 && (
          <div className="absolute top-0 left-0 overflow-hidden" style={{ width: VW, height: VH, transform: `scale(${scale})`, transformOrigin: "0 0" }}>
            {src && <Backdrop mode={kind === "video" ? "video" : "image"} url={abs(src)} map={map} frames={effectPlan((k) => content[k], src).items.map((f) => ({ url: abs(f.url), video: abs(f.video) || "" }))} secs={Number(content["hero.effect_secs"]) || 4} />}
            <div className={`absolute inset-0 pointer-events-none ${shade}`} />
            <SiteContentOverride content={content}>
              <div className={`absolute inset-0 flex items-center ${lay.startsWith("contour") ? "" : "pointer-events-none"}`}>
                <HeroLetters layout={lay} map={map} anchor={anchor} vw={VW} vh={VH} onQuoteClick={() => {}} edit={lay === "contour" ? { scale, onDrag } : null} />
              </div>
            </SiteContentOverride>
          </div>
        )}
      </div>
    </div>
  );
};
